"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var CardRowCheckBoxEditor = /** @class */ (function (_super) {
    __extends(CardRowCheckBoxEditor, _super);
    function CardRowCheckBoxEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.GRID_CARD_CSS = { width: '100%', textAlign: 'center', boxShadow: "none", padding: "10px" };
        return _this;
    }
    CardRowCheckBoxEditor.prototype.onCheckBoxChanged = function (checked) {
        if (this.props.onChecked) {
            this.props.onChecked(checked);
        }
    };
    CardRowCheckBoxEditor.prototype.render = function () {
        return (React.createElement(antd_1.Card.Grid, { style: this.GRID_CARD_CSS },
            React.createElement("div", { style: { display: "flex", flexDirection: "row", justifyContent: "flex-start", alignItems: "center" } },
                React.createElement(antd_1.Switch, { checked: this.props.value, onChange: this.onCheckBoxChanged.bind(this), disabled: this.props.disabled }),
                React.createElement("div", { style: { marginLeft: "5px" } }, this.props.title))));
    };
    return CardRowCheckBoxEditor;
}(React.Component));
exports.default = CardRowCheckBoxEditor;



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/editors/CardRowCheckBoxEditor.tsx
// module id = 24
// module chunks = 0